/** Fixed-capacity undo/redo stack of mask snapshots. */
export class MaskHistory {
    undoStack = [];
    redoStack = [];
    capacity;
    constructor(capacity = 50) {
        this.capacity = capacity;
    }
    clone(mask) {
        return { width: mask.width, height: mask.height, alpha: Uint8ClampedArray.from(mask.alpha) };
    }
    /** Call before applying a new edit, passing the mask state as it was *before* the edit. */
    push(previousState) {
        this.undoStack.push(this.clone(previousState));
        if (this.undoStack.length > this.capacity)
            this.undoStack.shift();
        this.redoStack = [];
    }
    canUndo() {
        return this.undoStack.length > 0;
    }
    canRedo() {
        return this.redoStack.length > 0;
    }
    /** Returns the mask to restore to, given the current mask (which is pushed onto the redo stack). */
    undo(current) {
        const previous = this.undoStack.pop();
        if (!previous)
            return null;
        this.redoStack.push(this.clone(current));
        return previous;
    }
    redo(current) {
        const next = this.redoStack.pop();
        if (!next)
            return null;
        this.undoStack.push(this.clone(current));
        if (this.undoStack.length > this.capacity)
            this.undoStack.shift();
        return next;
    }
    clear() {
        this.undoStack = [];
        this.redoStack = [];
    }
}
//# sourceMappingURL=history.js.map